export default {
  home: "/home",
  events: "/events",
  // New media library tab – lists every uploaded / directory video and lets
  // the admin transfer it between the local server and their own S3 bucket.
  media: "/media",
  normaluser:"/users",
  setting: "/setting",
  signup: "/signup",
  login: "/login",
  webinarView: "/webinarView",
  webinarEdit: "/webinarEdit",
  webinarJoin: "/webinarJoin",
  webinarAnalytics: '/webinarAnalytics',
  chatReport: "/chatReport",
  webinarAttendSuccess: "/webinarAttendSuccessfully",
  errorpage:"/*",
  recoverPassword:"/recoverPassword",
  forgetPassword:"/forgetPassword",
  webinarGhostUser:"/webinarGhostUser",
  // Knowledge-base / documentation page (S3 setup, Media tab how-to, FAQ).
  help: "/help",

};


